import { useServerFetch } from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';

export enum TerminalProvider {
    VB = 'VB',
    PM = 'PM',
    SKIDATA_CLOUD = 'SKIDATA_CLOUD',
    SKIDATA_CLOUD_V7 = 'SKIDATA_CLOUD_V7',
    Sitax = 'Sitax',
    SB = 'SB',
    DESIGNA = 'DESIGNA',
    HUB_PARKING = 'HUB_PARKING',
    CLOUD_CONNECTOR = 'CLOUD_CONNECTOR',
}

export interface OperatorParking {
    zoneId: number;
    name: string;
    city: string;
    zipCode: string;
    vatNumber: string | null;
    terminalId: string;
    terminalProvider: TerminalProvider;
    dtaAccountId: number | null;
    isOperatorStateActive: boolean;
    geodataText: string | null;
    hasLprReport: boolean;
    sortNumber: number | null;
    showSmartCall: boolean;
    isPublic: boolean;
}

export function useParkingsFetch() {
    return useServerFetch<OperatorParking[], object>(
        () => ({
            url: `/ui-api/operator-account/parkings`,
        }),
        {},
    );
}
